import React from "react";
import Errorpage from "../../assets/images/404 Error-bro.png";
import PropTypes from "prop-types";
import { Container, Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.png";

import { TNButton } from "./TNButton";
import "../../assets/scss/page/_notfound.scss";
const PageNotFound = () => {
  const navigate = useNavigate();

  /**
    This function will call on go to home button and will redirect user to dashboard 
   */
  const handleClick = () => {
    navigate("/dashboard");
  };
  return (
    <>
      <Navbar className="sticky-top navbar-section">
        <Container fluid className="container-section">
          <Navbar.Brand className="dashboard-logo">
            <img src={Logo} alt="dashboardlogo" className="nav-brand m-2" />
          </Navbar.Brand>
        </Container>
      </Navbar>
      <Container>
        <div className="page-not-found">
          <img src={Errorpage} alt="404" className="not-found-image" />
          <h1 className="page-heading-center">Oops!</h1>
          <div className="error-page-text">Page Not Found</div>
          <div className="primary-button">
            <TNButton onClick={handleClick} loading={false}>
              Back to Home
            </TNButton>
          </div>
        </div>
      </Container>
    </>
  );
};

PageNotFound.propTypes = {
  from: PropTypes.string,
  t: PropTypes.func,
};

export default PageNotFound;
